import type { IUsersMeApiUser } from '../types/UsersMe.api';
import type { ICurrentIdentity } from '../types/UsersMe';

/** Maps the auth-service person to the app shape; an omitted nullable field becomes `null`. */
export const toCurrentIdentity = (user: IUsersMeApiUser): ICurrentIdentity => ({
  id: user.id,
  email: user.email ?? null,
  phoneNumber: user.phoneNumber ?? null,
  firstName: user.firstName ?? null,
  lastName: user.lastName ?? null,
  userType: user.userType,
});
